import axios from "./axios-config";


export const getAdminProfile = async () => {

    let { data } = await axios.get(`/super-admin/superadmin-info`)
    return data;

}

export const updateAdminProfile = async (updateData) => {

    // let { data } = await axios.post(`/super-admin/users/${updateData.id}?_method=put`, updateData.data)
    let { data } = await axios.put(`/super-admin/superadmin-update`, updateData)
    return data;
}